import { createSlice } from "@reduxjs/toolkit";


const shiftSettingSlice = createSlice({
    name: "shiftSetting",
    initialState: {
        shiftData: []
    },
    reducers: {
        setShiftData: (state, action) => {
            state.shiftData = action.payload;
        },
    }
});

export const {
    setShiftData
} = shiftSettingSlice.actions;

export default shiftSettingSlice.reducer;